// extracted by mini-css-extract-plugin
export default {"cls1":"M8qUqrRyPf9Vdp7Lotje","cls2":"pICvM11XTIdQYTLFme1f M8qUqrRyPf9Vdp7Lotje"};